<template>
  <component
    :is="active ? Link : 'span'"
    :href="active ? url : null"
    :preserve-state="preserveState"
    :preserve-scroll="preserveScroll"
    :only="only"
    class="relative inline-flex items-center py-2 border border-gray-300 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-600"
    :class="[
      active
        ? 'hover:bg-gray-50 hover:text-gray-500 dark:hover:bg-gray-500 dark:hover:text-gray-100'
        : 'opacity-60',
      props.icon ? 'px-2' : 'px-4',
      rounded,
    ]"
  >
    <template v-if="props.icon">
      <ChevronLeftIcon
        v-if="props.type === 'previous'"
        class="h-5 w-5"
        aria-hidden="true"
      />
      <ChevronRightIcon v-else class="h-5 w-5" aria-hidden="true" />
    </template>
    <template v-else>
      {{ props.type === 'next' ? 'Next' : 'Previous' }}
    </template>
  </component>
</template>

<script setup>
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/solid'
import { Link } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'

const props = defineProps({
  meta: Object,
  preserveState: Boolean,
  preserveScroll: Boolean,
  only: Array,
  type: String,
  icon: Boolean,
})

const url = computed(() =>
  props.type === 'next'
    ? props.meta.links[props.meta.links.length - 1].url
    : props.meta.links[0].url
)

const active = computed(() =>
  props.type === 'next'
    ? props.meta.current_page != props.meta.last_page
    : props.meta.current_page != 1
)

const rounded = computed(() => {
  if (props.icon) {
    if (props.type === 'next') return 'rounded-r-md'
    else return 'rounded-l-md'
  }
  return 'rounded-md'
})
</script>
